import * as React from 'react';
import { MimeType } from "../../../common";
import { ThumbnailView } from './ThumbnailView';
import { CustomImageView } from './CustomImageView';
import { DocumentContainerView } from './DocumentContainerView';
import { ImageZoomedView } from './ImageZoomedView';
import { VideoPlayerView } from './VideoPlayerView';
import { PopoutImageZoomedView } from './PopoutImageZoomedView';
const showImagePreview = (type) => [MimeType.IMAGE_JPEG, MimeType.IMAGE_PNG, MimeType.IMAGE_GIF].includes(type);
const showVideoThumbnail = (type) => [
    MimeType.VIDEO_MP4,
    MimeType.VIDEO_MPEG,
    MimeType.VIDEO_AVI,
    MimeType.VIDEO_MOV,
    MimeType.VIDEO_WMV
].includes(type);
/**
 * Renders the desired CarouselView Component based on condition
 */
export const CarouselView = (carouselViewProps) => {
    let carouselViews = [
        new CustomImageCarouselView(),
        new DocumentCarouselView(),
        new ImageZoomedCarouselView(),
        new VideoplayerCarouselView()
    ];
    const { file, isDocumentPreviewEnabled, isZoomEnabled } = carouselViewProps;
    const carouselView = carouselViews.find((carouselview) => carouselview.isMatch(file, isDocumentPreviewEnabled, isZoomEnabled));
    return carouselView
        ? carouselView.render(carouselViewProps)
        : new ThumbnailCarouselView().render(carouselViewProps);
};
/**
 * Returns CustomImageView if condition satisfies
 */
class CustomImageCarouselView {
    isMatch(file, isDocumentPreviewEnabled, isZoomEnabled) {
        return showImagePreview(file.fileType) && !isZoomEnabled;
    }
    render(carouselViewProps) {
        return React.createElement(CustomImageView, { carouselViewProps: carouselViewProps });
    }
}
/**
 * Returns DocumentCarouselView if condition satisfies
 */
class DocumentCarouselView {
    isMatch(file, isDocumentPreviewEnabled, isZoomEnabled) {
        return (isDocumentPreviewEnabled &&
            !showImagePreview(file.fileType) &&
            !showVideoThumbnail(file.fileType));
    }
    render(carouselViewProps) {
        return React.createElement(DocumentContainerView, { carouselViewProps: carouselViewProps });
    }
}
/**
 * Returns ImageZoomedCarouselView if condition satisfies
 */
class ImageZoomedCarouselView {
    isMatch(file, isDocumentPreviewEnabled, isZoomEnabled) {
        return showImagePreview(file.fileType) && isZoomEnabled;
    }
    render(carouselViewProps) {
        return carouselViewProps.isPopoutCompatibilityEnabled ? (React.createElement(PopoutImageZoomedView, { carouselViewProps: carouselViewProps })) : (React.createElement(ImageZoomedView, { carouselViewProps: carouselViewProps }));
    }
}
/**
 * Returns VideoplayerCarouselView if condition satisfies
 */
class VideoplayerCarouselView {
    isMatch(file, isDocumentPreviewEnabled, isZoomEnabled) {
        return showVideoThumbnail(file.fileType);
    }
    render(carouselViewProps) {
        return React.createElement(VideoPlayerView, { carouselViewProps: carouselViewProps });
    }
}
/**
 * Returns ThumbnailCarouselView
 */
class ThumbnailCarouselView {
    render(carouselViewProps) {
        return React.createElement(ThumbnailView, { carouselViewProps: carouselViewProps });
    }
}
//# sourceMappingURL=CarouselView.js.map